var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',_vm._l((_vm.quantity),function(star){return _c('i',{key:star,staticClass:"material-icons star"},[_vm._v("star")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }